/** Screening question payloads from **`GET /api/opportunities/:id/questions`**. */
export type ScreeningQuestion = {
  id: string
  question_text: string
  is_required?: boolean
  question_type: string
  config?: {
    options?: string[]
    validation?: { min_value?: number; max_value?: number }
  }
}

export type ApplicationAnswerValue = string | number | boolean | string[]

export function answerString(value: ApplicationAnswerValue | undefined): string {
  return typeof value === 'string' ? value : ''
}

export function answerStringOrNumber(value: ApplicationAnswerValue | undefined): string | number {
  return typeof value === 'string' || typeof value === 'number' ? value : ''
}

export function answerStringArray(value: ApplicationAnswerValue | undefined): string[] {
  return Array.isArray(value) ? value : []
}
